import {ReactNode, useLayoutEffect, useRef} from "react";
import {useReducedMotion} from "framer-motion";

const STEP_CONTENT_TRANSITION_MS = 220;
const STEP_CONTENT_TRANSITION_EASING = "cubic-bezier(0.4, 0, 0.2, 1)";

interface IProps {
    children: ReactNode;
    className?: string;
    contentKey: string;
    /** A short slide in, used when the summary comes back. */
    settle?: boolean;
}

export const UserFlowModalStepContentTransition = (props: IProps) => {
    const {children, className, contentKey, settle = false} = props;
    const shouldReduceMotion = useReducedMotion();
    const frameRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const heightRef = useRef<number | null>(null);
    const isFirstRef = useRef(true);

    useLayoutEffect(() => {
        const frame = frameRef.current;
        const content = contentRef.current;

        if (!frame || !content) return;

        frame.getAnimations?.().forEach((animation) => animation.cancel());

        const next = content.scrollHeight;
        const previous = heightRef.current;
        const isFirst = isFirstRef.current;

        isFirstRef.current = false;

        if (next > 0) heightRef.current = next;

        const sameHeight = previous === next;

        if (isFirst || shouldReduceMotion || previous == null || previous <= 0 || next <= 0 || (sameHeight && !settle)) return;

        if (typeof frame.animate !== "function" || typeof content.animate !== "function") return;

        if (!sameHeight) {
            frame.animate(
                [
                    {height: `${previous}px`, overflow: "hidden"},
                    {height: `${next}px`, overflow: "hidden"}
                ],
                {
                    duration: STEP_CONTENT_TRANSITION_MS,
                    easing: STEP_CONTENT_TRANSITION_EASING
                }
            );
        }

        content.animate(
            settle
                ? [
                      {opacity: 0, transform: "translateY(0.8rem)"},
                      {opacity: 1, transform: "translateY(0)"}
                  ]
                : [{opacity: 0}, {opacity: 1}],
            {
                duration: STEP_CONTENT_TRANSITION_MS,
                easing: STEP_CONTENT_TRANSITION_EASING
            }
        );
    }, [contentKey, settle, shouldReduceMotion]);

    return (
        <div ref={frameRef}>
            <div className={className} key={contentKey} ref={contentRef}>
                {children}
            </div>
        </div>
    );
};
import {ReactNode, useLayoutEffect, useRef} from "react";
import {useReducedMotion} from "framer-motion";

const STEP_CONTENT_TRANSITION_MS = 220;
const STEP_CONTENT_TRANSITION_EASING = "cubic-bezier(0.4, 0, 0.2, 1)";

interface IProps {
    children: ReactNode;
    className?: string;
    contentKey: string;
    /** A short slide in, used when the summary comes back. */
    settle?: boolean;
}

export const UserFlowModalStepContentTransition = (props: IProps) => {
    const {children, className, contentKey, settle = false} = props;
    const shouldReduceMotion = useReducedMotion();
    const frameRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const heightRef = useRef<number | null>(null);
    const isFirstRef = useRef(true);

    useLayoutEffect(() => {
        const frame = frameRef.current;
        const content = contentRef.current;

        if (!frame || !content) return;

        frame.getAnimations?.().forEach((animation) => animation.cancel());

        const next = content.scrollHeight;
        const previous = heightRef.current;
        const isFirst = isFirstRef.current;

        isFirstRef.current = false;

        if (next > 0) heightRef.current = next;

        const sameHeight = previous === next;

        if (isFirst || shouldReduceMotion || previous == null || previous <= 0 || next <= 0 || (sameHeight && !settle)) return;

        if (typeof frame.animate !== "function" || typeof content.animate !== "function") return;

        if (!sameHeight) {
            frame.animate(
                [
                    {height: `${previous}px`, overflow: "hidden"},
                    {height: `${next}px`, overflow: "hidden"}
                ],
                {
                    duration: STEP_CONTENT_TRANSITION_MS,
                    easing: STEP_CONTENT_TRANSITION_EASING
                }
            );
        }

        content.animate(
            settle
                ? [
                      {opacity: 0, transform: "translateY(0.8rem)"},
                      {opacity: 1, transform: "translateY(0)"}
                  ]
                : [{opacity: 0}, {opacity: 1}],
            {
                duration: STEP_CONTENT_TRANSITION_MS,
                easing: STEP_CONTENT_TRANSITION_EASING
            }
        );
    }, [contentKey, settle, shouldReduceMotion]);

    return (
        <div ref={frameRef}>
            <div className={className} key={contentKey} ref={contentRef}>
                {children}
            </div>
        </div>
    );
};
